import {Store} from 'ui.vue3.vuex';
import 'x.vue.loader';
import {notify} from 'app.vue.components.notifications';

const control = {
    init () { // инициализация
        vuex.dispatch('init');
    },
}

const storage = {
    // сохраняет данные в хранилище
    save (key, data, expire) {
        let storageKey = 'vuex-'+key;
        let storageKeyExp = 'vuex-'+key+'-exp';
        
        localStorage.setItem(storageKey,JSON.stringify(data));
        localStorage.setItem(storageKeyExp,parseInt(expire));
    },
    
    // получаем данныех из хранилища
    read (key) {
        let storageKey = 'vuex-'+key;
        let storageKeyExp = 'vuex-'+key+'-exp';
        let now = Date.now()/1000;
        
        let data = localStorage.getItem(storageKey); // пытаемся поднять данные из LS
        
        if (data && data.length) { // данные есть
            let exp = localStorage.getItem(storageKeyExp);
            // и не устарели
            //console.log('app.vue.vuex',exp, now);
            if (exp && exp > now) { // проверяем что данные не устарели
                return JSON.parse(data); // отдаем
            }
        }
        return false;
    },
    
    clear (key) {
        let storageKey = 'vuex-'+key;
        let storageKeyExp = 'vuex-'+key+'-exp';
        
        localStorage.removeItem(storageKey);
        localStorage.removeItem(storageKeyExp);
    }
    
}

/*
 * некоторые ключи Vuex которые автоматически загружаются во время инициализации хранилича
 * point - точка к которой надо обратиться
 * 
 * params - данные которые надо передать в виде параметров в контроллер
 * expire - если больше 0, данные будут сохранены на клиенте на столько секунд,
 *      т.е. при expire - данные не будут запрашиваться с севера в течении 100 секунд,
 *      а будут считываться из хранилища на клиенте
 *
 * Так же ключи указанные тут можно перезагрузить с сервера по пимени вызвав action reload:
 *      this.$store.dispatch('reload', key); где key - имя ключа который надо перезагрузить
 *
 * Если компонент получает на запрос готовые данные, которые нужно записать в ключ, то следует использовать экшен update
 *      this.$store.dispatch('update',{key:'basket', data:response.data}); - для перезагрузки данных в корзине,
 *      как в компоненте basket.order
 *      
*/
const shema = {
    // общие данны
    'config': { // TODO: придумать способ коррекции времени
            point: '/api/v1/config/',
            method: 'get',
            params: {}
        }, // некоторые константы битрикс, параметры окружения, и опции проекта
    'statuses': { // 
            point: '/api/v1/invoice/statuses/',
            method: 'get',
            params: {}
        },
};

const vuex = new Store(
{
    // это одновременно и признак отладки
    strict: true, //storeData.config?.env?.stage == 'dev',
    
    state: {},
    
    actions: {
        
        init ({state,dispatch,commit})
        { // экшен инициализации хранилища

            if (this.strict) console.log('app.vue.vuex','Инициализация vuex');

            // перебираем данные которые мы должны получать от сервера
            for (let key in shema) {
                let documentsCarrier = document.querySelector('script[type="extension/settings"][name="'+key+'"]');
                let data;
                if (documentsCarrier) {
                    data = JSON.parse(documentsCarrier.innerText);
                    if (this.strict) console.log('app.vue.vuex','данные из носителя в документе',data);
                } else {
                    data = storage.read(key); // пробуем прочитать данные из локального хранилища
                }
                if (!data) {
                    dispatch('reload', key); // и запрашиваем с сервера если их нет
                } else {
                    commit('update',{'key':key, 'data':data}); // ... востаналвиваем если есть
                    if (this.strict) console.log('app.vue.vuex','Из хранилища данные секции', key);
                }
            }
        },
        
        reload ({dispatch}, key)
        {
            // перегрузка списка ключей
            let now = Date.now()/1000;
            let point = shema[key].point;
            let method = shema[key].method || 'get';
            if (point) {
                let data = Object.assign({
                        timestamp: now,
                        sessid: BX.bitrix_sessid()
                    }, shema[key].params);
                
                
                BX.ajax[method](
                        point,
                        data,
                        (response) => {
                            try {
                                response = JSON.parse(response);

                                if (response.status == 'error') {
                                    if (this.strict) {
                                        console.error('app.vue.vuex','Ответ не содержит данных для ключа '+key, response);
                                    }
                                    if (response.errors) {
                                        for (let error of response.errors) {
                                            console.error('app.vue.vuex','Ошибка при загрузки точки '+point, error.message);
                                            if (error.code == 'invalid_csrf') {
                                                notify.error('Ваша сессия устарела','Пожалуйста, обновите страницу и попробуйте снова. Если это не помогает, попробуйте очистить куки для этого сайта.');
                                            }
                                        }
                                    }
                                } else if (response.status == 'success') {
                                    if (response.data) {
                                        dispatch('update',{key:key, data:response.data});
                                    }
                                }

                                if (this.strict) console.log(
                                        'app.vue.vuex',
                                        'Получены данные из точки '+point,
                                        response
                                    );

                            } catch (error) {
                                console.error(
                                        'app.vue.vuex',
                                        'Ошибка при загрузки точки '+point,
                                        error,
                                        response
                                    );
                            }
                            // //console.log(response);

                        }
                    );
            }
        },
        
        
        update ({commit}, payload)
        {
            let key = payload.key
            let data = payload.data

            
            commit('update',{key:key, data:data});
            if (this.strict) console.log('app.vue.vuex','Обновлены данные секции', key, data);

            
            // сохрнаемя данные в локальное хранилище
            if (shema[key].expire) { // ... если данные вообще нужно сохранять на клиенте
                let now = Date.now()/1000;
                let expire = now+shema[key].expire;
                storage.save(key, data, expire);
            }

            
            // выполним onUpdate
            //if (shema[key].onUpdate) {
            //    shema[key].onUpdate(data);
            //}
        }
    },
    
    mutations: {
        /*
         * Все изменения проходящие через эту мутацию (в оснонвм это данные из sheme)
         * отслеживаются плагином шаринга который синхронизирует эти данные между вкладками
         * что позволяет актуализировать корзину, избранное и т.п.
         * не следует использовать эту мутацию для данных которые не должны быть синхронны во всех вкладках
         * т.е. для данных не связанных с пользователем (как избранное или корзина) или сервером (как config),
         * а связанных со страницеей как данные о товаре.
         *
         * Для таких данных нужно использовать мутацию updateLocal
         * 
        */
        update (state,params) {
            state[params.key] = params.data;
        },
        
        /*
         * Мутация загружает ключ в хранилище аналогично update,
         * но не шарит его между вкладками (не отслеживается плагином vuex-shared-mutations)
        */
        updateLocal (state,params) {
            state[params.key] = params.data;
        },
    }
});

vuex.control = control;
//vuex.storage = storage;

window.addEventListener('load', ()=>{
        //setTimeout(vuex.control.init,2000);
        vuex.control.init();
    });

BX.X.Vue.loader.addStore(vuex);

export {vuex};


